// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#staff-block p{margin-bottom:0}#staff-block .MuiInputBase-root{max-width:315px;width:100%}#staff-block .color-light input{font-family:\"HelveticaNeueCyr-Light\",\"Helvetica\",sans-serif;color:#626264}@media (max-width: 767px){#staff-block .MuiInputBase-root{max-width:unset}}\n", ""]);
// Exports
module.exports = exports;
